import { render } from "./GenerateSAPApprovalDialog.vue?vue&type=template&id=00be2bad&scoped=true"
import script from "./GenerateSAPApprovalDialog.vue?vue&type=script&lang=ts"
export * from "./GenerateSAPApprovalDialog.vue?vue&type=script&lang=ts"

import "./GenerateSAPApprovalDialog.vue?vue&type=style&index=0&id=00be2bad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-00be2bad"

export default script